import React from "react";
import Toggler from "./toggler/Toggler";
import appstyles from "./styles/app.module.css"
import VideoPoster from "./toggler/VideoPoster";
import VideoPlayer from "./toggler/VideoPlayer";
function App() {

 const [togglerStatus, setTogglerStatus] = React.useState("female")
 const [isModal, setIsModal] = React.useState(false);
 const [videoToPlay, setVideotoPlay] = React.useState({videoid:0 });


  return (
    <div className="App">

        <section className={appstyles.videomasterframe}>


 <section className={appstyles.videposterframe}>
     <div className={appstyles.videoarea}>
     <h2>Themenbereich <br/>Bestattungsvorsorge</h2>
    <VideoPoster area="Bestattungsvorsorge" setVideoToPlay = {setVideotoPlay} setIsModal = {setIsModal} videoToPlay ={videoToPlay}/>
     </div>

     <div className={appstyles.videoarea}>
         <h2 style={{width:"100%"}}>Themenbereich <br/>Trauerfall</h2>
         <VideoPoster area="Trauerfall" setVideoToPlay = {setVideotoPlay} setIsModal = {setIsModal} videoToPlay ={videoToPlay}/>
     </div>


      <div className={appstyles.videoarea}>
     <h2 style={{width:"100%"}}>Themenbereich <br/>Bestattungskultur</h2>
     <VideoPoster area="Kultur" setVideoToPlay = {setVideotoPlay} setIsModal = {setIsModal} videoToPlay ={videoToPlay}/>
     </div>  <div className={appstyles.videoarea}>
     <h2 style={{width:"100%"}}>Themenbereich <br/>Bestattungsarten</h2>
     <VideoPoster area="Bestattungsarten" setVideoToPlay = {setVideotoPlay} setIsModal = {setIsModal} videoToPlay ={videoToPlay}/>
 </div>
     <div className={appstyles.videoarea}>
         <h2 style={{width:"100%"}}>Themenbereich <br/>Unternehmen</h2>
         <VideoPoster area="Bolz" setVideoToPlay = {setVideotoPlay} setIsModal = {setIsModal} videoToPlay ={videoToPlay}/>
     </div>   <div className={appstyles.videoarea}>
         <h2 style={{width:"100%"}}>Themenbereich <br/>Ratgeber</h2>
         <VideoPoster area="Ratgeber" setVideoToPlay = {setVideotoPlay} setIsModal = {setIsModal} videoToPlay ={videoToPlay}/>
     </div>
 </section>
            {
                isModal

                ? (
<VideoPlayer videotoPLay = {videoToPlay} setIsModal = {setIsModal}/>
                    ):("")

                    }


        </section>

        </div>
  );
}

export default App;
